import { useCallback } from "react";
import { selectorFamily, useRecoilValue, useRecoilRefresher_UNSTABLE } from "recoil";
import { COMMUNICATE_ERROR_MESSAGE_CHART_LIST, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from "../constants/ErrorMessage";
import axios from "axios";
import { userState } from "./UserState";

// API
// Customer Chart
const _listCustomerChart = async (data) => {
	const apiUrl = process.env.REACT_APP_CHART_API_URL;
	const apiKey = process.env.REACT_APP_CHART_API_KEY;
	const config = {
		method: 'GET',
		url: `${apiUrl}/company-setting/chart-setting/list`,
		headers: {
			'x-api-key': apiKey
		},
		params: data,
		errorHandle: {
			message: COMMUNICATE_ERROR_MESSAGE_CHART_LIST,
			additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
		}
	};
	
	return await axios(config)
		.then(response => {
			const list = response.data || [];
			return list;
		})
		.catch(() => {
			return [];
		});
};

const _updateCustomerChart = async (data) => {
	const apiUrl = process.env.REACT_APP_CHART_API_URL;
	const apiKey = process.env.REACT_APP_CHART_API_KEY;
	const config = {
		method: 'PUT',
		url: `${apiUrl}/company-setting/chart-setting/update`,
		headers: {
			'Content-Type': 'application/json',
			'x-api-key': apiKey
		},
		data: data,
	};
	
	return await axios(config)
		.then(response => {
			const res = response.data;
			return res;
		});
};


/* チャートstate */
const customerChartListState = selectorFamily({
	key: 'customerChartListState',
	get: (data) => () => _listCustomerChart(data),
});

export const useCustomerChartList = () => {
	const user = useRecoilValue(userState);
	const contractParams = { contractId : user.contract };
	const customerChartList = useRecoilValue(customerChartListState(contractParams));

	const ref1 = useRecoilRefresher_UNSTABLE(customerChartListState(contractParams));

	const refresher = useCallback(() => {
		ref1();
	}, [ref1]);

	const updateCustomerChart = useCallback(data => {
		const require = [
			'contractId',
			'chartId',
			'updateTime',
			'isEnable',
			'apiExecUser',
		];

		const _data = Object.assign({}, data, {
			contractId: user.contract,
			apiExecUser: user.userId,
		});

		if (!require.every(v => v in _data)) {
			throw new Error('Unset require parameter');
		};

		return _updateCustomerChart(_data)
			.then(refresher)
	}, [refresher, user]);

	return {
		customerChartList,
		updateCustomerChart,
		refreshCustomerChartList: refresher,
	}
};
